import { BaseRepository } from '../Firestore/BaseRepository'
import { ICollection } from 'firebase-firestorm'
import { QuickbooksUpdate } from './QuickbooksUpdate'
import { Collection } from 'firebase-firestorm/lib'
import { QuickbooksUpdateTypeEnum } from './QuickbooksUpdateTypeEnum'

export class QuickbooksUpdateRepository extends BaseRepository<QuickbooksUpdate> {
  public async findPreviousUpdates(id: string, type: QuickbooksUpdateTypeEnum, companyId: string) {
    const query = this.getCollection().query()
      .where('id', '==', id)
      .where('type', '==', type)
      .where('restaurantId', '==', companyId)
      .get()

    return ( await query ).docs
  }

  public async findUnsentUpdate(id: string, type: QuickbooksUpdateTypeEnum, companyId: string): Promise<QuickbooksUpdate | undefined> {
    const query = this.getCollection().query()
      .where('id', '==', id)
      .where('type', '==', type)
      .where('restaurantId', '==', companyId)
      .orderBy('createdAt', 'desc')
      .limit(1)
      .get()

    const latest = ( await query ).docs[0]
    return latest.sentAt ? undefined : latest
  }

  public async findByExport(exportId: string) {
    const query = this.getCollection().query()
      .where('exportId', '==', exportId)
      .get()

    return ( await query ).docs
  }

  public qAllUpdates(companyId: string, limit: number = 200) {
    return this.getCollection().query()
      .where('restaurantId', '==', companyId)
      .orderBy('createdAt', 'desc')
      .limit(limit)
  }

  protected getCollection(): ICollection<QuickbooksUpdate> {
    return Collection(QuickbooksUpdate)
  }

  protected getNewInstance(): QuickbooksUpdate {
    return new QuickbooksUpdate()
  }
}
